import React, { SVGProps } from 'react';

const SvgIcCopy = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    {...props}
  >
    <g fill="currentColor" fillRule="nonzero" stroke="none" strokeWidth="1">
      <path d="M28 11v17H11V11h17zm-2 2H13v13h13V13z"></path>
      <path d="M20 3L20 8.46153846 18 8.46153846 18 5 5 5 5 18 8.46153846 18 8.46153846 20 3 20 3 3z"></path>
    </g>
  </svg>
);

export default SvgIcCopy;
